import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
    TrackedButton as Button,
    TrackedDialog as Dialog,
    TrackedIconButton as IconButton,
} from '../../../components/TrackedComponents';

interface DeleteModalProps {
    isReport: boolean;
    onClose: CallableFunction;
    onDelete: CallableFunction;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ isReport, onClose, onDelete }) => {
    const { t } = useTranslation();
    const reportType = t(`content.reports.${isReport ? 'report' : 'alert'}`);

    return (
        <Dialog id="report-details-dialog" open={true} onClose={() => onClose()}>
            <Box
                sx={{
                    backgroundColor: 'secondary.main',
                    position: 'sticky',
                    top: 0,
                    p: 1,
                }}
            >
                <Box sx={{ position: 'absolute', display: 'flex', right: 0, top: 0, mt: 0.5, mr: 0.5 }}>
                    <IconButton id="btn-close-modal" size="small" onClick={() => onClose()}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <DeleteIcon sx={{ mr: 0.5 }} />
                    {t('content.reports.delete_report', { reportType })}
                </Box>
            </Box>
            <Paper
                sx={{
                    backgroundColor: 'bgColor.main',
                    pt: 1,
                    pb: 2,
                    px: 3,
                    borderRadius: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography>{t(`content.reports.confirm_delete_${isReport ? 'report' : 'alert'}`)}</Typography>
                <Box sx={{ display: 'flex', mt: 1 }}>
                    <Button
                        id="cancel-delete-btn"
                        data-testid="cancel-delete-btn"
                        variant="contained"
                        color="primary"
                        onClick={() => onClose()}
                        sx={{ mr: 1 }}
                    >
                        {t('content.reports.cancel')}
                    </Button>
                    <Button
                        id="confirm-delete-btn"
                        data-testid="confirm-delete-btn"
                        variant="contained"
                        color="error"
                        onClick={() => {
                            onClose();
                            onDelete();
                        }}
                    >
                        {t('content.reports.delete')}
                    </Button>
                </Box>
            </Paper>
        </Dialog>
    );
};

export default DeleteModal;
